export default "__VITE_ASSET__D55iOYN$__";